import React, { Component } from 'react';
import { Icon, Button } from 'react-materialize';

import CartItem from './CartItem';
import FileUtils from '../../utils/FileUtils';
import EventUtils from '../../utils/EventUtils';
import NuxeoClient from '../../clients/NuxeoClient';
import CommonConstants from '../../constants/CommonConstants';

import './CartSidebar.css';

class CartSidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      cartSize: 0,
      downloading: false
    };

    this._handleItemDelete = this._handleItemDelete.bind(this);
    this._handleClearClick = this._handleClearClick.bind(this);
    this._handleDownloadClick = this._handleDownloadClick.bind(this);
    this._handleRunReportClick = this._handleRunReportClick.bind(this);
  }

  get items() {
    return this.state.items;
  }

  set items(items) {
    this.setState({ items:  Array.from(new Set(items)) }, () => {
      const { items } = this.state;
      let cartSize = 0;

      for (let i = 0; i < items.length; i++) {
        if(items[i].properties['file:content']){
        cartSize += parseInt(items[i].properties['file:content'].length);
        }
      }
      const cartItemCount = this.state.items.length;
      EventUtils.raiseEvent('update-cart-item-count', { count: cartItemCount }, this.props);

      this.cartSize = cartSize;
    });
  }

  get cartSize() {
    return this.state.cartSize;
  }

  set cartSize(cartSize) {
    this.setState({ cartSize: cartSize });
  }

  get downloading() {
    return this.state.downloading;
  }

  set downloading(downloading) {
    this.setState({ downloading: downloading });
  }

  _handleItemDelete(event) {
    let itemIndex = event.detail.index;
    let newItems = this.items;

    newItems.splice(itemIndex, 1);
    this.items = newItems;
    
    EventUtils.raiseEvent('item-deleted', { items: newItems }, this.props);
  }

  _handleClearClick(event) {
    this.items = [];
    EventUtils.raiseEvent('item-deleted', { items: [] }, this.props);
  }

  _handleDownloadClick(event) {
    this.downloading = true;
    window.Materialize.toast('Download is in progress...', 2000);

    let filesUids = this.items.map(item => item.uid);
    NuxeoClient
      .instance()
      .startBulkDownload('Cart.zip', filesUids, () => this.downloading = false )
  }

  _handleRunReportClick(event) {
    const { items } = this.state;
    EventUtils.raiseEvent('run-report', { items: items }, this.props);
  }

  render() {
    const { items, cartSize, downloading } = this.state;
    const { hidden, view } = this.props;

    return (
      <aside className="cart-sidebar" style={ hidden ? { left: '-320px' } : {} }>
        <div id="container">
          <div className="content">
            <div className={view === 'assetview' ? 'asset-item-list items-list' : 'submission-item-list items-list'}>
              { 
                items.map((item, index) => {
                  let views = item.properties['picture:views'];
                  let subtitle = item.type === CommonConstants.ARCHIVE_ASSETS_FILE_TYPE ? item.properties['archive_file:archiveSubmissionId'] : item.properties['submission:propertyName'];
                  let thumbnail = views[CommonConstants.FILE_VIEWS_THUMBNAIL] ? views[CommonConstants.FILE_VIEWS_THUMBNAIL].content.data : null;
                  return (<CartItem key={index} id={index}  thumbnail={ thumbnail } title={ item.title } subtitle={ subtitle } onDelete={ this._handleItemDelete } />);
                })
              }
            </div>
            <div className="toolbar">
               <div className="actions" style={{'display': view === 'assetview' ? 'block' : 'none'}}>
                <div className="layout horizontal">
                  <Button waves='light' style={{ fontSize: '10px' }} disabled={ items.length === 0 } onClick={ this._handleRunReportClick }>
                    Run Report
                    <Icon left>bar_chart</Icon>
                  </Button>
                </div>
              </div>
              <div className="actions">
                <div className="layout horizontal">
                  <Button waves='light' style={{ fontSize: '10px' }} disabled={ items.length === 0 } onClick={ this._handleClearClick }>
                    Clear
                    <Icon left>remove_shopping_cart</Icon>
                  </Button>
                  <Button waves='light' style={{ fontSize: '10px' }} disabled={ items.length === 0 || downloading } onClick={ this._handleDownloadClick }>
                    Download
                    <Icon left>file_download</Icon>
                  </Button>
                </div>
              </div>
            </div>
            <label className="cart-size">Cart Size: { FileUtils.getHumanReadableSize(cartSize) }</label>
          </div>
        </div>
      </aside>
    );
  }
}

export default CartSidebar;
